import React from 'react'
import thumbsup from 'images/thumbs/thumbsup.png'
import thumbsdown from 'images/thumbs/thumbsdown.png'

export const SearchResultsColumns = [{
  label: 'Articles',
  width: '300px'
}, {
  label: 'Status',
  width: '130px'
},{
  label: 'Created',
  width: '120px'
}, {
  label: 'Updated',
  width: '120px'
}, {
  label: <span aria-label="Thumbs up emoji" role="img" style={{fontSize: '20px'}}><img width="20" src={thumbsup} alt="thumbs up"/></span>,
  width: '50px'
}, {
  label: <span aria-label="Thumbs down emoji" role="img" style={{fontSize: '20px'}}><img src={thumbsdown} width="20" alt="thumbs down"/></span>,
  width: '100px'
}, {
  label: '',
  width: '5%'
}, {
  label: '',
  width: '10%'
}]

export const AdditionalArticlesColumns = [{
  label: '',
  width: '5px'
},
{
  label: 'Additional Articles',
  width: '300px'
}, {
  label: 'Status',
  width: '130px'
},{
  label: 'Created',
  width: '120px'
}, {
  label: 'Updated',
  width: '120px'
}, {
  label: <span aria-label="Thumbs up emoji" role="img" style={{fontSize: '20px'}}><img width="20" src={thumbsup} alt="thumbs up"/></span>,
  width: '50px'
}, {
  label: <span aria-label="Thumbs down emoji" role="img" style={{fontSize: '20px'}}><img src={thumbsdown} width="20" alt="thumbs down"/></span>,
  width: '100px'
}, {
  label: '',
  width: '5%'
}, {
  label: '',
  width: '10%'
}]

export const SectionArticleColumns = [{
  label: '',
  width: '5px'
},
{
  label: 'Article',
  width: '300px'
}, {
  label: 'Status',
  width: '130px'
},{
  label: 'Created',
  width: '120px'
}, {
  label: 'Updated',
  width: '120px'
}, {
  label: <span aria-label="Thumbs up emoji" role="img" style={{fontSize: '20px'}}><img width="20" src={thumbsup} alt="thumbs up"/></span>,
  width: '50px'
}, {
  label: <span aria-label="Thumbs down emoji" role="img" style={{fontSize: '20px'}}><img src={thumbsdown} width="20" alt="thumbs down"/></span>,
  width: '100px'
}, {
  label: '',
  width: '5%'
}, {
  label: '',
  width: '10%'
}]